module.exports = __webpack_public_path__ + "static/img/1_1_1_3.71c641ca.jpg";